import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function LoginForm({ onSwitch }) {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src="/logo-playventr.png" alt="PlayVentr" style={{ height: 48, margin: '0 auto 12px', display: 'block' }} />
          <div style={{ fontSize: 13, color: '#94A3B8', marginTop: 6, fontFamily: 'Poppins, sans-serif' }}>
            Pitch smarter. License faster.
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(24px)',
          border: '1px solid #E2E8F0', borderRadius: 20,
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)', padding: 32,
        }}>
          <h2 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 28, fontWeight: 700, color: '#0F172A', margin: '0 0 24px' }}>
            Sign In
          </h2>

          {error && (
            <div style={{
              marginBottom: 20, padding: 12, borderRadius: 12,
              background: '#FEF2F2', border: '1px solid #FECACA', color: '#F97066', fontSize: 13,
              fontFamily: 'Poppins, sans-serif',
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#0F172A', marginBottom: 6, fontFamily: 'Poppins, sans-serif' }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%', padding: '12px 16px', borderRadius: 12,
                  border: '2px solid #E2E8F0', fontSize: 15, fontFamily: 'Poppins, sans-serif',
                  background: 'rgba(255,255,255,0.7)', color: '#0F172A', outline: 'none',
                  transition: 'border-color 0.2s', boxSizing: 'border-box',
                }}
                onFocus={e => e.target.style.borderColor = '#c9a84c'}
                onBlur={e => e.target.style.borderColor = '#E2E8F0'}
              />
            </div>

            <div style={{ marginBottom: 28 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#0F172A', marginBottom: 6, fontFamily: 'Poppins, sans-serif' }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: '100%', padding: '12px 16px', borderRadius: 12,
                  border: '2px solid #E2E8F0', fontSize: 15, fontFamily: 'Poppins, sans-serif',
                  background: 'rgba(255,255,255,0.7)', color: '#0F172A', outline: 'none',
                  transition: 'border-color 0.2s', boxSizing: 'border-box',
                }}
                onFocus={e => e.target.style.borderColor = '#c9a84c'}
                onBlur={e => e.target.style.borderColor = '#E2E8F0'}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '14px 28px', borderRadius: 14,
                background: loading ? '#d4b96a' : '#c9a84c', color: 'white',
                fontSize: 15, fontWeight: 600, fontFamily: 'Poppins, sans-serif',
                border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.15s', boxShadow: '0 2px 8px rgba(201,168,76,0.3)',
              }}
              onMouseEnter={e => { if (!loading) { e.target.style.background = '#a88a2e'; e.target.style.transform = 'translateY(-1px)'; e.target.style.boxShadow = '0 4px 16px rgba(201,168,76,0.4)'; }}}
              onMouseLeave={e => { e.target.style.background = '#c9a84c'; e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 2px 8px rgba(201,168,76,0.3)'; }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p style={{ marginTop: 24, textAlign: 'center', fontSize: 13, color: '#94A3B8', fontFamily: 'Poppins, sans-serif' }}>
            Don't have an account?{' '}
            <button
              onClick={onSwitch}
              style={{ background: 'none', border: 'none', color: '#c9a84c', fontWeight: 600, cursor: 'pointer', fontFamily: 'Poppins, sans-serif', fontSize: 13 }}
            >
              Create one
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
